import { iAdmin } from "@/services";
const state = {
  checkedList: [],
  paymentList: [],
};

const mutations = {
  setCheckedList: (state, data) => {
    state.checkedList = data;
  },
  clearCheckedList: () => {
    state.checkedList = [];
  },
  setPaymentList: (state, data) => {
    state.paymentList = data;
  },
  clearPaymentList: () => {
    state.paymentList = [];
  },
};

const actions = {
  async deleteUserList(_, payload) {
    const res = await iAdmin.deleteUser(payload.data);
    if (res.data.code !== "") {
      alert(`[Error] while delete User : ${res.data.code}`);
      return;
    } else {
      payload.callback(res);
    }
  },
  async resetPassword(_, payload) {
    const res = await iAdmin.resetPassword(payload.data);
    if (res.data.code !== "") {
      alert(`[Error] while reset password : ${res.data.code}`);
      return;
    } else {
      payload.callback(res);
    }
  },
  async createUser(_, payload) {
    const res = await iAdmin.createUser(payload.data);
    if (res.data.code !== "") {
      alert(`[Error] while create user : ${res.data.code}`);
      return;
    } else {
      payload.callback(res);
    }
  },
  async updatePaymentStatus(_, payload) {
    const res = await iAdmin.setPaymentStatus(payload.data);
    if (res.data.code !== "") {
      alert(`[Error] while create user : ${res.data.code}`);
      return;
    } else {
      payload.callback(res);
    }
  },
  async updatePaymentDate(_, payload) {
    const res = await iAdmin.setPaymentDate(payload.data);
    if (res.data.code !== "") {
      alert(`[Error] while create user : ${res.data.code}`);
      return;
    } else {
      payload.callback(res);
    }
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
